"use client";

//This is a wrapper for the ReduxPopupModal component
//It is used to provide the modalOpen and modalMessages to the component
//It is also used to provide the dispatch to the component

import { type ModalMessage, ReduxPopupModal } from "@/packages/common/src/components/modals/ReduxPopupModal";
import type React from "react";
import { useEffect, useState } from "react";
import { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "./store";
import { setModalMessages, setModalOpen } from "./uiSlice";

interface ReduxPopupModalWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const ReduxPopupModalWrapper = forwardRef<HTMLDivElement, ReduxPopupModalWrapperProps>(({ className, ...props }, ref) => {
  const modalOpen = useSelector((state: RootState) => state.ui.modalOpen);
  const modalMessages = useSelector((state: RootState) => state.ui.modalMessages);
  const dispatch = useDispatch();

  return (
    <ReduxPopupModal
      modalOpen={modalOpen}
      modalMessages={modalMessages as ModalMessage[]}
      dispatch={dispatch}
      setModalOpen={setModalOpen}
      setModalMessages={setModalMessages}
      {...props}
    />
  );
});

ReduxPopupModalWrapper.displayName = "ReduxPopupModalWrapper";
